module.exports = __webpack_public_path__ + "static/community-ccfa1a179e34b8240742112d4a02b5ca.svg";